(function ($) {
  // Delegate .transition() calls to .animate()
  // if the browser can't do CSS transitions.
  if (!$.support.transition) $.fn.transition = $.fn.animate;
  /**
   * Locale de la page courante
   */
  var locale = $('html').attr('lang');
  /**
   * Initialisation des champs de type date
   */
  $('.type_date').datepicker($.datepicker.regional[locale]);
  /**
   * Les rubriques externes doivent s'ouvrir dans des nouvelles
   */
  $('ul:not(#menu_principal) > li > a.type_rubrique_0004').click(function (e) {
    e.preventDefault();
    window.open(this.href);
    return false;
  });
  /**
   * Permet d'associer un rôle de "fermeture" à un bouton. Code à suivre :
   * <div>
   *     <button role="close">&times;</button>
   *     <!-- ... -->
   * </div>
   */
  $(document).on('click', '[role="close"]', function (e) {
    $(this).parent().hide();
  });
  /**
   * Datagrid des résultats de recherche de formations
   */
  if ($("#resultatSelecteur")) {
    $("#resultatSelecteur").dataTable();
  }
  /**
   * Share actions
   */
  $('.js-share-action').on('click', function (e) {
    e.preventDefault();
    var href = $(this).attr('href');
    window.open(href, '', 'height=400,width=600,titlebar=yes');
    return false;
  });
  $(function () {
    // Owl Carousel
    $('.owl-carousel').each(function () {
      let $t = $(this);
      let willBeAnimated = $t.find('.slideshow__item__wrapper').length > 1;
      let isAutoplay = $t.attr("autoplay") && willBeAnimated;
      let isAutoplayHoverPause = $t.attr("autoplayHoverPause") && willBeAnimated;
      let autoplayTimeoutAttr = $t.attr("autoplayTimeout");
      if (autoplayTimeoutAttr === '' || Number.isNaN(autoplayTimeoutAttr)) {
        autoplayTimeoutAttr = 8000;
      }
      let smartSpeedAttr = $t.attr("smartSpeed");
      if (smartSpeedAttr === '' || Number.isNaN(smartSpeedAttr)) {
        smartSpeedAttr = 200;
      }
      $t.owlCarousel({
        items: 1,
        margin: 10,
        loop: willBeAnimated,
        nav: false,
        autoplay: isAutoplay,
        mouseDrag: willBeAnimated,
        touchDrag: willBeAnimated,
        autoplayTimeout: autoplayTimeoutAttr,
        lazyLoad: true,
        autoplayHoverPause: isAutoplayHoverPause,
        smartSpeed: smartSpeedAttr,
      });
      $t.find('.owl-controls').prepend('<button class="owl-prev">&lt;</button>').append('<button class="owl-next">&gt;</button>');
      $t.find('.owl-controls .owl-prev').click(function () {
        $t.trigger('prev.owl.carousel');
      }).end().find('.owl-controls .owl-next').click(function () {
        $t.trigger('next.owl.carousel');
      });
    });
    // Owl Carousel
    $('.owl-carousel-accueil').each(function () {
      let $t = $(this);
      let willBeAnimated = $t.find('.carrousel-item').length > 1;
      $t.owlCarousel({
        items: 1,
        margin: 10,
        loop: willBeAnimated,
        nav: true,
        dots: true,
        autoplay: willBeAnimated,
        mouseDrag: willBeAnimated,
        touchDrag: willBeAnimated,
        autoplayTimeout: 8000,
        lazyLoad: true,
        autoplayHoverPause: true
      });
      $t.find('.owl-controls').prepend('<button class="owl-prev">&lt;</button>').append('<button class="owl-next">&gt;</button>');
      $t.find('.owl-controls .owl-prev').click(function () {
        $t.trigger('prev.owl.carousel');
      }).end().find('.owl-controls .owl-next').click(function () {
        $t.trigger('next.owl.carousel');
      });
    });
  });

  function matches(el, selector) {
    if (!el) {
      return false;
    }
    var matchesCallable = (el.matches || el.matchesSelector || el.msMatchesSelector || el.mozMatchesSelector || el.webkitMatchesSelector || el.oMatchesSelector);
    if (!matchesCallable) {
      return false;
    }
    return matchesCallable.call(el, selector);
  }

  function closest(el, fn) {
    return el && (fn(el) ? el : closest(el.parentNode, fn));
  }

  function parentMatches(el, selector) {
    return closest(el, function (e) {
      return matches(e, selector);
    }) !== null;
  }

  var dataToggleAttr = 'data-toggle'; // odf = offre de formation
  (new DataToggle({
    preventingCallback: function (event, $element, $target, $el) {
      if (parentMatches($el, '[data-toggle-group-keep].active')) { // prevent close of tab contents)
        event.preventDefault();
        return true;
      }
      return (
        parentMatches($el, '.kTree') ||
        parentMatches($el, '.ui-dialog') ||
        parentMatches($el, '.owl-carousel') ||
        parentMatches($el, '.plier-deplier') ||
        parentMatches($el, '.kmultiselect-ltl') ||
        (parentMatches($el, '[data-toggle-target]') && !matches($el, '[data-toggle]')) || matches($el, '[data-toggle-target]')// prevent click inside dropdowns
      );
    }
  }));
  $(window).on('load resize', function (e) {
    if ($(window).width() >= 768) {
      $('.menu__level--1 > div').attr('data-toggle-target', '');
    } else {
      $('.menu__level--1 > div').removeAttr('data-toggle-target');
    }
  });

  function switchCookieState() {
    var $refuse = $('.cookie__button--refuse'),
      $accept = $('.cookie__button--accept'),
      $status = $('.cookie__status');
    if (CookieCNIL.hasConsent()) {
      $accept.css('display', 'none');
      $refuse.css('display', 'inline-block');
      $status.html('<span class="icon icon-checkmark" style="color: #009B06"></span>' + COOKIES_CNIL.messages.accepted);
    } else {
      $refuse.css('display', 'none');
      $accept.css('display', 'inline-block');
      $status.html('<span class="icon icon-close" style="color: #c50202"></span>' + COOKIES_CNIL.messages.refused);
    }
  }

  $('.cookie__button--accept').click(function (e) {
    CookieCNIL.accept();
    switchCookieState();
  });
  $('.cookie__button--refuse').click(function (e) {
    CookieCNIL.decline();
    switchCookieState();
  });
  if (window.CookieCNIL) {
    switchCookieState();
  }
  //Mise en forme des listes
  $("#page .objets .avec_vignette").each(function () {
    if ($(this).find(".vignette_deco").length) {
      var vignetteDeco = $(".vignette_deco", this);
      var imgVignetteDeco = $(".vignette_deco img", this);
      if (imgVignetteDeco.attr("src") != undefined) {
        vignetteDeco.css("background-image", "url('" + imgVignetteDeco.attr("src") + "')"); //background image sur le conteneur à partir du src de l'image
      }
    }
  });

  // liste bloc
  function adpatListe() {
    $(".objets.actualites.carte li ").each(function () {
      var titreHeight = $(this).find("[class*='lien__actualite__']").outerHeight();
      $(this).find("[class*='date__actualite__']").css("bottom", titreHeight).css("top", "auto");
    });
  }

  adpatListe();
  $(window).resize(function () {
    adpatListe();
  });
  // Accordion Style de paragraphe4
  $('.paragraphe__titre--4').click(function () {
    $(this).toggleClass("active");
  });
  $(".paragraphe__contenu--4").slideToggle(); // hide all nested lists
  $(".paragraphe__contenu--4").prev(".paragraphe__titre--4").click(function () { // add fn to list items that have a nested list
    $(this).next(".paragraphe__contenu--4").slideToggle(100); // show/hide the nested list
    return false; // prevent scrolling
  });
  //Formatage des fiches
  $(".contenu .photo>img").each(function () {
    $(this).parent(".photo").css("background-image", "url('" + $(this).attr("src") + "')").addClass("has_background");
  });
  // Fichiers joints hover
  $("#telecharger li>a[href]").each(function () {
    var link_href = $(this).attr('href');
    var parent_li = $(this).parent("li");
    if (link_href != "" && link_href != undefined) {
      $(parent_li).addClass("has_link");
      $(parent_li).click(function () {
        window.location.href = link_href;
      });
    }
  });
  //UDLREC-33 : on filtre les paragraphes de type 0 qui ne contiennent rien
  $(".paragraphe__contenu--0").each(function () {
    $(this).find('p, div, span').filter(function () {
      return $(this).html().trim().replace(/&nbsp;|&#160;/g, '').length === 0;
    }).remove();
  });
  //UDLREC-43: popup ???
  $('a.lien_externe[href]:link').click(function (e) {
    e.preventDefault();
    window.open($(this).attr('href'));
    return false;
  });
})(jQuery.noConflict());
